import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
export function FinalCTA() {
  return <section className="border-t-4 border-electric bg-white py-5 sm:py-8" data-id="element-40" data-mp="c83odh06bg3y">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-41" data-mp="8448n0mpwlbn">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-42" data-mp="m4yk5s52b2ej">
          One last <span className="text-electric" data-id="element-43" data-mp="m2lv6v0vzrrz">question</span>
        </h2>
        <p className="mx-auto mt-2 max-w-3xl text-center text-sm font-medium leading-snug text-muted sm:text-base" data-id="element-44" data-mp="h5c6jhlbnk57">
          When an appliance develops a fault and several components could be
          responsible... Do you immediately know what you should check and test next?
          Stop jumping between scattered references and replacing suspected components
          without systematically isolating the actual problem. Identify the symptom.
          Check the system. Test the components. Isolate the fault.{' '}
          <strong className="font-bold text-navy" data-id="element-45" data-mp="2c70ztsnlefs8">Identify. Check. Test. Diagnose.</strong>
        </p>

        <MockupImage className="mt-3" data-id="element-46" data-mp="2h5kmjva0fvln" />

        <div className="mt-3 text-center" data-id="element-47" data-mp="2m2krg2v4isb6">
          <p className="font-display text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-48" data-mp="2m4xbqmoctere">
            🔧 {PRODUCT}
          </p>
          <p className="mx-auto mt-1 max-w-2xl text-xs font-semibold uppercase leading-tight tracking-wide text-muted sm:text-sm" data-id="element-49" data-mp="2v4amdio7s9dp">
            {PRODUCT_TAGLINE}
          </p>
          <p className="mt-1 font-display text-xs font-extrabold uppercase tracking-widest text-electric sm:text-sm" data-id="element-50" data-mp="34tc35b2l2usq">
            Identify • Check • Test • Compare • Isolate • Diagnose
          </p>
        </div>

        <div className="mt-3 flex flex-col items-center" data-id="element-51" data-mp="3es1j2yax656c">
          <p className="mb-2 font-display text-base font-extrabold uppercase leading-tight text-navy sm:text-xl" data-id="element-52" data-mp="3epf1e5ube9ae">
            🔥 GET THE COMPLETE SYSTEM TODAY
          </p>
          <CTAButton href={OFFER_ANCHOR} data-id="element-53" data-mp="1jp4vjuay17pg">⚡ GET HOME APPLIANCE DIAGNOSTIC PRO™</CTAButton>
          <TrustLine items={['Immediate Access • Digital Delivery', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-54" data-mp="1eqbext0d10l2" />
        </div>
      </div>
    </section>;
}